// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loading-overlay .loading-icon:after {\n  width: 2em;\n  height: 2em;\n  top: calc(50% - 1em);\n}\n.loading-overlay .loading-background {\n  border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
